import React, { useState, useEffect, useCallback } from "react";
import IcUpload from "../../components/Svg/IcUpload";
import IcEye from "../../components/Svg/IcEye";
import styles from "./style.module.css";
import { ModalImageView } from "../Modal";
import Tooltip2 from "../../components/Tooltip";
import { useDropzone } from "react-dropzone";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";

export default function File(props) {
  const { file_id, setFile, file_to_upload, title, name, noPreview, disabled = false } = props;
  const { config } = useWrapper();
  const [view, setview] = useState(false);
  const [fileLoaded, setfileLoaded] = useState();
  useEffect(() => {
    if (!!file_id) {
      (async () => {
        const { data: _file } = await api.get(`files/${file_id}/download`, config);
        setfileLoaded({
          name: _file?.name,
          url: _file?.download,
        });
      })();
    }
  }, [file_id]);

  const [fileDroped, setfileDroped] = useState();
  const onDropFile = useCallback(__files => {
    setfileDroped(
      __files.map(e =>
        Object.assign(e, {
          preview: URL.createObjectURL(e),
        }),
      )[0],
    );
  }, []);

  useEffect(() => {
    !!fileDroped && setFile(fileDroped);
  }, [fileDroped]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: false,
    maxFilesize: 20971520, // 20 MB
    onDrop: onDropFile,
  });

  return (
    <>
      <div className={styles.file_input} {...getRootProps()}>
        {!disabled && <input {...getInputProps()} />}
        <input name={name} disabled="true" value={file_to_upload?.name || fileLoaded?.name} />
        {!file_to_upload && !fileLoaded && <span className={styles.placeholder}>Adicionar Arquivo...</span>}
        <div className={styles.actions}>
          {!disabled && (
            <Tooltip2 tip="Subir Arquivo">
              <span className="small-ico">
                <IcUpload />
              </span>
            </Tooltip2>
          )}
          {(file_to_upload || fileLoaded) && !noPreview && (
            <Tooltip2 tip="Visualizar Arquivo">
              <span
                className="small-ico"
                onClick={ev => {
                  ev.stopPropagation();
                  setview(!view);
                }}
              >
                <IcEye />
              </span>
            </Tooltip2>
          )}
        </div>
      </div>
      <ModalImageView
        image={file_to_upload?.preview || fileLoaded?.url}
        view={view}
        closeModal={() => {
          setview(false);
        }}
        title={title}
      />
    </>
  );
}
